import { getLocalUserInfo } from "../utility/authHelper";
import TripListRoutes from "./routes/TripList";
import Ticket from "./routes/Ticket";
import CounterFundRequestRoutes from "./routes/CounterFundRequest";
import StaticRoutes from "./routes/Static";
import UserManagementRoutes from "./routes/UserManagement";
import CounterPanel from "./routes/CounterPanel";
import TripOnBoard from "./routes/TripOnBoard";
import Coach from "./routes/Coach";
import StaffUser from "./routes/StaffUser";
import SeatMigration from "./routes/SeatMigration";
import CounterDashboardReports from "./routes/CounterDashboardReports";

const tempRoutes = [
    ...UserManagementRoutes,
    ...TripListRoutes,
    ...CounterPanel,
    ...TripOnBoard,
    ...StaffUser,
    ...SeatMigration,
    ...Coach,
    ...Ticket,
    ...CounterFundRequestRoutes,
    ...CounterDashboardReports,
];

const getPermittedRoutes = () => {
    const { permissions } = getLocalUserInfo();
    return getRoutes(tempRoutes, permissions || []);
};

const filterableSidebarMenus = [];

const getRoutes = (routes, permissions, showChildren = false) => {
    const permittedRoutes = [];
    routes.forEach((route) => {
        if (route.children && route.children.length) {
            route.children = getRoutes(
                route.children,
                permissions,
                route.showChildren
            );
            if (route.children.length) {
                permittedRoutes.push(route);
                addInFilterableSidebarMenus(route);
            }
        } else {
            if (route.permissions && route.permissions.length) {
                const availablePermsissions = route.permissions.filter(
                    (permission) => permissions.includes(permission)
                );

                if (availablePermsissions.length) {
                    permittedRoutes.push(route);
                    if (showChildren) addInFilterableSidebarMenus(route);
                }
            } else {
                permittedRoutes.push(route);
                if (showChildren) addInFilterableSidebarMenus(route);
            }
        }
    });

    return permittedRoutes;
};

const addInFilterableSidebarMenus = (route) => {
    if (route.sidebarMenu) {
        filterableSidebarMenus.push(route);
    }
};

const permittedRoutes = getPermittedRoutes();

const CounterRoutes = [...StaticRoutes, ...permittedRoutes];

export default CounterRoutes;
